import { render, staticRenderFns } from "./RadiologistProfile.vue?vue&type=template&id=38065cf2"
import script from "./RadiologistProfile.vue?vue&type=script&lang=js"
export * from "./RadiologistProfile.vue?vue&type=script&lang=js"
import style0 from "./RadiologistProfile.vue?vue&type=style&index=0&id=38065cf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports